@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

.modalHeader {
	background-color: Colors.$col-greyBackground;
	color: Colors.$col-greyInactive;
	font-size: Constants.$val-fontSizeBig;
	font-weight: bold;
	display: flex; 
		
	.userName {
		color: Colors.$col-black;
		margin-left: Constants.$val-spacing-xs;
	}
}

.inheritedBodyProps {
	padding: 0 !important;
}

.modalBody {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	padding-bottom: Constants.$val-spacing-s;

	.modalMessage {
		font-size: Constants.$val-fontSizeRegular;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		color: Colors.$col-design-grey15;
		white-space: pre-line;
		line-height: Constants.$val-lineHeightRegular;
	}

	.numberOfSelected {
		font-size: Constants.$val-fontSizeRegular;
		padding: Constants.$val-spacing-s 0;
		font-style: italic;
		color: Colors.$col-greyInactive;
		white-space: pre-line;
		line-height: Constants.$val-lineHeightRegular;
	}
	.timeSheetEntry {
		display: flex;
		flex-direction: row;
		padding: Constants.$val-spacing-s Constants.$val-spacing-l;

		.workTypeIcon{
			flex: 0.5;
			color: Colors.$col-canceledRed;
			display: flex;
			align-self: center;
			justify-content: center;
			
			& [class^="icon-"] {
				font-size: Constants.$val-fontSizeXBig;
			}
		}

		.workTypeInfo{
			flex: 5;
			display: flex;
			flex-direction: column;

			.firstRow{
				display: flex;
				flex-direction: row;
				
				.workType {
					font-weight: bold;
				}

				.workOrderCode {
					margin-left: Constants.$val-spacing-s;
				}
				.unassigned {
					margin-left: Constants.$val-spacing-s;
					color: Colors.$col-canceledRed;
					font-size: Constants.$val-fontSizeSmall;
					align-self: center;
				}
			}

			.secondRow{
				display: flex;
				flex-direction: row;

				.startEndTime {
					color: Colors.$col-greyInactive;
					font-size: Constants.$val-fontSizeSmall;
					padding: 0 Constants.$val-spacing-xxs;
				}
			}

			.workOrderCodeSeparator {
				margin-left: Constants.$val-spacing-s;
				border-left: 1px solid Colors.$col-greyFontLight;
				height: auto;
			}
		}

		.workTypeDuration{
			flex: 1;
			font-weight: bold;
			display: flex;
			align-self: center;
			justify-content: center;
		}

		.workTypeEditIcon{
			flex: 0.5;
			display: flex;
			align-self: center;
			justify-content: center;
		}

		.checkbox {
			color: Colors.$col-darkBlueBorder;
			font-weight: bold;
			display: flex;
			align-self: center;
			justify-content: center;
			font-size: Constants.$val-fontSizeBig;
		}
	}
}

.footerButtons {
	padding-bottom: Constants.$val-spacing-m;
	& > * + * {
		margin-left: Constants.$val-spacing-xs;
	}
}